<template>
    <SideHeader :to="'/profile'" />

    <div style="padding-top: 55px;">
        <div class="wide-block py-2">
            <ul class="nav nav-tabs capsuled" role="tablist">
                <li class="nav-item" @click="getTransaction('all')">
                    <a class="nav-link active" data-bs-toggle="tab" role="tab">
                        همه
                    </a>
                </li>
                <li class="nav-item" @click="getTransaction(100)">
                    <a class="nav-link" data-bs-toggle="tab" role="tab">
                        پرداخت موفق
                    </a>
                </li>
                <li class="nav-item" @click="getTransaction(0)">
                    <a class="nav-link" data-bs-toggle="tab" role="tab">
                        پرداخت ناموفق
                    </a>
                </li>
            </ul>
        </div>
        <Placeholder v-if="loading" />

        <div v-else class="section full mt-2">
            <div class="section mt-2">
                <CardTransaction v-for="(item, index) in transactions" :key="index" :transaction="item" />
            </div>
        </div>
    </div>
    <!-- <Footer /> -->

</template>

<script>
// import Footer from '@/components/footer.vue';
import Placeholder from '@/components/Placeholder.vue';
import SideHeader from '@/components/SideHeader.vue';
import CardTransaction from '@/views/transaction/components/CardTransaction.vue';
import axios from "axios";

export default {
    name: "transaction",
    data() {
        return {
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            },
            loading: true,
            statusData : 'all',
            transactions: []
        }
    },
    methods: {
        getTransaction(status = 'all') {
            this.statusData = status;
            this.loading = true;
            axios.get(`https://xpanel.s-bar.ir/api/driver/transaction/${status}`, this.axiosConfig)
                .then((response) => {
                    this.loading = false
                    this.transactions = response.data.data;
                });
        },
    },
    mounted() {
        this.getTransaction();
    },
    components: {
        SideHeader,
        CardTransaction,
        Placeholder
        // Footer
    }
};
</script>

<style scoped></style>